import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/shared/constants';
import { fetchTeamMembers } from '../../api';

/**
 * Assignable Azure DevOps project team members for the developer-assignment
 * picker (Story 5.4). Cached for 5 minutes to avoid hammering the ADO API —
 * team membership changes rarely. Enabled lazily so the list is only fetched
 * when the picker is actually rendered.
 */
export function useTeamMembers(enabled = true) {
  return useQuery({
    queryKey: [QUERY_KEYS.BUG_TEAM_MEMBERS],
    queryFn: fetchTeamMembers,
    staleTime: 5 * 60 * 1000,
    enabled,
  });
}
